import React, { useState, useImperativeHandle, useEffect, useCallback }from 'react';
import { Toast } from 'antd-mobile';
import requst from '../../utils/req';
import ProtocolDetails from '../ProtocolDetails/index'

// import { useTitle} from '../../utils/useFunc';
import style from './style.module.css';
import jquery from 'jquery'
export default function(props){
    let [phoneVal,setphoneVal] = useState(''); //手机号码
    let [verification, setVerification] = useState(''); //验证码
    let [interTime, setInterTime] = useState(null); //验证码间隔计时器
    let [intervalTime, setIntervalTime] = useState(60) //获取验证码间隔时间
    let [verBtnText, setPerBtnText] = useState('获取验证码'); //验证码按钮
    let [checked, setChecked] = useState(false); //是否同意协议
    let [userPhone, setUserPhone] = useState('');//判断用户是否登录过
    let [radioClassName, setRadioClassName] = useState(style.simulationCheckbox)//协议按钮样式
    let [show,setShow] = useState('none') // 滑动按钮显示状态

    // 加载NVC_Opt
    useEffect(()=>{
      setAuth().then(res=>{
        getAliJs()  // 保证先在window下存在变量NVC_Opt再去加载js文件
      })
    },[])
    // 改变协议
    const changeAgree = useCallback((bol) => {
        if(bol){
            setRadioClassName(style.simulationCheckbox_active);
        }else{
            setRadioClassName(style.simulationCheckbox);

        }
    },[])
    // 协议按钮
    const changeBtn = useCallback((bol) => {
            setChecked(bol)
            sessionStorage.setItem('checked',bol);
            changeAgree(bol);
    },[changeAgree])

    useEffect(() => {
        if(sessionStorage.getItem('member_id') || localStorage.getItem('member_id')){
            let getPhone = sessionStorage.getItem('phone') || localStorage.getItem('phone');
            let hidPhone = getPhone.substring(getPhone.length - 11,getPhone.length - 8) + '****' + getPhone.substring(getPhone.length - 4);
            setUserPhone(hidPhone);
            props.changeSubFlag(true)
        }
    },[setUserPhone])

    useEffect(() => {
        if(localStorage.getItem('phone') || sessionStorage.getItem('phone')){
            let phoneNumber = localStorage.getItem('phone') || sessionStorage.getItem('phone')
            setphoneVal(phoneNumber);
            setVerification(sessionStorage.getItem('verification'))
            setChecked(sessionStorage.getItem('checked'));
        }
    },[setphoneVal,setVerification,changeAgree])

    // 验证所填信息是否有效
    function validataInfo(type){
        let flag = false;
        let validata = {
            verifiPhone(){
                if((sessionStorage.getItem('phone') || phoneVal !== '') && phoneVal.length === 11){
                    flag = false;
                }else{
                    flag = true;
                }
            },
            verifiProofscheme(){
                verification !== '' ? flag = false : flag = true;
            },
            verifiCheckd(){
                if(sessionStorage.getItem('member_id')){
                    flag = false
                }else{
                    checked ? flag = false : flag = true;
                }
            },
        }
        validata[type]();
        return flag;
    }
    // 获取手机和验证码
    function validateForm(value,validaName){
        let vadalitor = {
            phone(){
                setphoneVal(value);
            },
            verification(){
                setVerification(verification = value)
            }
        }
        vadalitor[validaName]()
        if(verification && phoneVal){
            props.changeSubFlag(true)
        }else{
            props.changeSubFlag(false)
        }
    }

    function getAliJs (){
      // 动态加载ali js文件
      try {
        var stamp = Math.trunc(Date.now() / 3600000);
        var script = document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        script.setAttribute('src', 'https://g.alicdn.com/sd/nvc/1.1.112/guide.js?t=' + stamp);
        document.documentElement.appendChild(script);
      } catch (e) {
    
      }
    }
    function setAuth(){   // window 挂载对象
      return new Promise((resolve,reject)=>{
        window.NVC_Opt = {
          //无痕配置 && 滑动验证、刮刮卡、问答验证码通用配置
          appkey:'FFFF0N00000000009A1E',
          scene:'nvc_message_h5',
          // appkey:'CF_APP_1',
          // scene:'nvc_register_h5',
          isH5:true,
          popUp:false,
          renderTo:'#captcha',
          nvcCallback:function(data){
            setShow('none')
          // console.log('-----data-----',data);
          const phoneVal = sessionStorage.getItem('phoneN')
          // console.log(phoneVal,'hahahahha');
          // console.log('phone',phoneVal);
          // let nvcval = data;
          aliAuth(data,'200',phoneVal)
          setIntervalTime(intervalTime = 60)
          Toast.loading('加载中...', 1);
          setInterTime(interTime = setInterval(() => {
            if (intervalTime <= 0) {
              clearTime();
              setPerBtnText(verBtnText = '获取验证码')
            } else {
              setIntervalTime(intervalTime -= 1);
              setPerBtnText(verBtnText = intervalTime);
            }
          }, 1000))
          // data为getNVCVal()的值，此函数为二次验证滑动或者刮刮卡通过后的回调函数
          // data跟业务请求一起上传，由后端请求AnalyzeNvc接口，接口会返回100或者900
  
          },
          // trans: {"key1": "code0","nvcCode":400},
          trans:{'nvcCode':400, 'key1':'code0'},
          // trans: {'nvcCode':600, 'key1': 'code0'},
          // trans: {"nvcCode":800},
          language: "cn",
          //滑动验证长度配置
          customWidth: 300,
          //刮刮卡配置项
          width: 300,
          height: 100,
          elements: [
              '//img.alicdn.com/tfs/TB17cwllsLJ8KJjy0FnXXcFDpXa-50-74.png',
              '//img.alicdn.com/tfs/TB17cwllsLJ8KJjy0FnXXcFDpXa-50-74.png'
          ], 
          bg_back_prepared: '//img.alicdn.com/tps/TB1skE5SFXXXXb3XXXXXXXXXXXX-100-80.png',
          bg_front: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABQCAMAAADY1yDdAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURefk5w+ruswAAAAfSURBVFjD7cExAQAAAMKg9U9tCU+gAAAAAAAAAIC3AR+QAAFPlUGoAAAAAElFTkSuQmCC',
          obj_ok: '//img.alicdn.com/tfs/TB1rmyTltfJ8KJjy0FeXXXKEXXa-50-74.png',
          bg_back_pass: '//img.alicdn.com/tfs/TB1KDxCSVXXXXasXFXXXXXXXXXX-100-80.png',
          obj_error: '//img.alicdn.com/tfs/TB1q9yTltfJ8KJjy0FeXXXKEXXa-50-74.png',
          bg_back_fail: '//img.alicdn.com/tfs/TB1w2oOSFXXXXb4XpXXXXXXXXXX-100-80.png',
          upLang:{"cn":{
              _ggk_guide: "请在屏幕上滑动，刮出两面盾牌",
              _ggk_success: "恭喜您成功刮出盾牌<br/>继续下一步操作吧",
              _ggk_loading: "加载中",
              _ggk_fail: ['呀，盾牌不见了<br/>请', "javascript:NoCaptcha.reset()", '再来一次', '或', "https://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN", '反馈问题'],
              _ggk_action_timeout: ['我等得太久啦<br/>请', "javascript:NoCaptcha.reset()", '再来一次', '或', "https://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN", '反馈问题'],
              _ggk_net_err: ['网络实在不给力<br/>请', "javascript:NoCaptcha.reset()", '再来一次', '或', "https://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN", '反馈问题'],
              _ggk_too_fast: ['您刮得太快啦<br/>请', "javascript:NoCaptcha.reset()", '再来一次', '或', "https://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN", '反馈问题']
              }
          }
        }
        resolve('成功'); // 成功
      })
    }
    // 无痕 / 滑动验证 请求
    function aliAuth(nvcval,type,phoneVal){
      // console.log('phoneVal',phoneVal);
      jquery.ajax({  // 阿里云对接请求
        url:'https://service.agent.pro.caixuetang.cn?c=verification&a=sendorlogin&v=app&serviceversion=v1&site=user',
        type:'post',
        dataType:'json',
        data:{
          sms_type: '1',
          ali_verify_type: 'traceless',
          member_mobile: phoneVal,
          appcode: sessionStorage.getItem('appCode'),
          nvcval //阿里云返回的参数
        },
        success(res){
          // console.log(res);
          if(res.code === 1){
            if(res.data === 1){
              Toast.success('发送成功');
              return false
            }else if(res.data !== 1){
              clearTime()
              if(res.data.BizCode == 400) {
                setShow('block')
                window.removeEventListener('click',sendVerCode,false)
                //唤醒滑动验证
                window.getNC().then(function(){
                    window.NoCaptcha.upLang('cn', {
                        'LOADING':"加载中...",//加载
                        'SLIDER_LABEL': "请向右滑动验证",//等待滑动
                        'CHECK_Y':"验证通过",//通过
                        'ERROR_TITLE':"非常抱歉，这出错了...",//拦截
                        'CHECK_N':"验证未通过", //准备唤醒二次验证
                        'OVERLAY_INFORM':"经检测你当前操作环境存在风险，请输入验证码",//二次验证
                        'TIPS_TITLE':"验证码错误，请重新输入"//验证码输错时的提示
                    });
                    
                    window._nvc_nc.reset();
                })
            } else if (res.data.BizCode == 600) {
                //唤醒刮刮卡
                window.getSC().then(function(){})
            } else if (res.data.BizCode == 700) {
                //唤醒问答验证码
                window.getLC()
            } else if (res.data.BizCode == 100 || res.data.BizCode == 200) {
              // resolve(json.result.result)
                //注册成功
                window.nvcReset()
                // alert("register success!")
            } else if (res.data.BizCode == 800 || res.data.BizCode == 900) {
                //直接拦截
                Toast.loading('验证码发送失败，请刷新页面重试',3);
                window.nvcReset()
                // alert("register failed!")
            }
          }
          }else{
            Toast.fail(res.message)
            clearTime()
          }
        }
      })
    }

    // 获取验证码
    async function sendVerCode(){
      if(!phoneVal){
        Toast.fail('请填写手机号')
        return
      }
      sessionStorage.setItem('phoneN',phoneVal)
        if(interTime){return};
        if(!interTime){
            setIntervalTime(intervalTime = 60)
            Toast.loading('加载中...',1);
            setInterTime(interTime = setInterval(() => {
                if(intervalTime <= 0){
                    clearTime();
                    setPerBtnText(verBtnText = '获取验证码')
                }else{
                    setIntervalTime(intervalTime -= 1);
                    setPerBtnText(verBtnText = intervalTime);
                }
            }, 1000))
        }
        await aliAuth(window.getNVCVal(),'200',phoneVal)
        // requst.post('//api.caixuetang.cn/index.php?c=verification&a=send&v=1.0',{
        //     mobile: phoneVal,
        //     type: '200'
        // })
        // .then((res) => {
        //     Toast.hide();
        //     if(res.code != 1){
        //         clearTime();
        //         Toast.fail(res.message)
        //     }
        // })
    }
    // 清楚定时器
    function clearTime(){
        clearInterval(interTime);
        setInterTime(interTime = null);
        setPerBtnText(verBtnText = '获取验证码')
    }
    // 跳转详情
    function hrefDetails(){
        clearTime();
        sessionStorage.setItem('phone',phoneVal);
        sessionStorage.setItem('verification',verification);
        props.changeShowAgreement(true);
        setChecked(true)
        changeBtn(true)
    }
    //登录
    async function login(){
        if(!localStorage.getItem('phone')){
            if(validataInfo('verifiPhone')){
                return await {
                    message: '手机号码格式错误'
                };
            }else if(validataInfo('verifiProofscheme')){
                return await {
                    message: '验证码错误！请重新输入'
                };
            }else if(validataInfo('verifiCheckd')){
                return await {
                    message: '请同意用户协议'
                };
            }
            Toast.loading('加载中...',1);
            return await requst.post('//service.agent.pro.caixuetang.cn?c=user&a=signinorregister&v=app&site=user',{
              mobile: phoneVal,
              code: verification,
              channel_new: sessionStorage.getItem('channel'),
              appcode: sessionStorage.getItem('appCode')
          })
        }else{
            return await new Promise((res, rej) => {
                res("localStorage")
            })
        }


    }
    // 暴露登录方法
    useImperativeHandle(props.Lref,() => ({
        login:login,
        checked: checked,
        phoneNumber: phoneVal
    }))

    return (
        <div className={style.login}>
            {
                userPhone === "" ?
                            <div>
                                <div className={style.form}>
                                    <div className={style.phone}>
                                        <div className={style.phone_box}>
                                            <input type="tel" placeholder="请输入手机号码" defaultValue={ phoneVal } onChange={ (v) => { validateForm(v.target.value,'phone')} } maxLength="11"/>
                                        </div>
                                    </div>
                                    <div className={style.verificationCode}>
                                        <div className={style.verificationCode_box}>
                                            <input type="text" placeholder="请输入短信验证码" maxLength={6} defaultValue ={ verification } onChange={ (v) => { validateForm(v.target.value,'verification')} }/>
                                            <button onClick={sendVerCode} className={style.ver_btn}>{ verBtnText }</button>
                                        </div>
                                    </div>
                                </div>
                                <div id="captcha" style={{display:show}}></div>
                                <div className={style.agreement}>
                                    <div className={style.checkbox}>
                                        <div className={radioClassName} onClick={() => {changeBtn(!checked)}}></div>
                                    </div>
                                    <div className={style.agreeementContent}>
                                        <span>同意</span>
                                        <div className={style.protocolDe} onClick={() => {hrefDetails()}}>《用户服务协议》</div>
                                        {/* <span>和</span>
                                        <div className={style.protocolDe} onClick={() => {hrefDetails('privacy')}}>《购买协议》</div> */}
                                    </div>
                                </div>  
                            </div>
                                :
                                <div className={style.userPhone}>
                                    <span>上课手机号：</span>
                                    { userPhone }
                                </div>
            }
        </div>
    )
}